{
	"signIn": {
		"clientId": {
			"production": "404493852178-k7v3co66ahlgd8fu6327oia1b24bk916.apps.googleusercontent.com",
			"staging": "542918937675-7itlknt420qv5hc5ffcvn5fktkh756vm.apps.googleusercontent.com",
			"demo": "1017659228853-3mh02b6fvnivvn0dkl35tko4h0ra4e45.apps.googleusercontent.com",
			"development": "1017659228853-3mh02b6fvnivvn0dkl35tko4h0ra4e45.apps.googleusercontent.com"
		}
	}
}
